<template>
  <div>
    <template v-if="useActablStyles">
      <div class="wrapper">
        <div :class="{ bar: true }" />
        <div
          class="release"
          style="top: 32; right: 180"
        >
          <a
            href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071"
            target="_blank"
            class="group default-color"
          >
            Release notes
          </a>
        </div>
        <div class="actablStylesContainer">
          <div class="logo">
            <div style="display: flex; align-items: center; padding-top: 25px">
              <img :src="NewPSLogo">
              <div style="padding-left: 3%; padding-bottom: 3%">
                <div>
                  <img :src="ProfitswordLogo">
                  <div class="logo-line" />
                </div>
                <!-- by actbl -->
                <div
                  style="
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding-left: 75%;
                  "
                >
                  <img
                    :src="ByPSLogo"
                    alt="by"
                  >
                  <img
                    :src="ActblPSLogo"
                    alt="actbl"
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="login-item">
            <v-form
              v-if="!isSso"
              class="form-login form"
              @keyup.native.enter="logIn"
            >
              <div class="input-label">
                <label>Username</label>
              </div>
              <div class="form-field">
                <input
                  id="username"
                  v-model="username"
                  prepend-icon="person"
                  type="text"
                  :label="translate('label.username')"
                  :error="!!error"
                  :error-messages="error"
                  outline
                  dense
                  autofocus
                  class="form-input"
                  placeholder="Your Username"
                >
              </div>
              <div class="input-label">
                <label>Password</label>
              </div>
              <div class="form-field">
                <input
                  id="password"
                  v-model="password"
                  postapend-icon="lock"
                  type="password"
                  :label="translate('label.password')"
                  :error="!!error"
                  :error-messages="error"
                  outline
                  dense
                  class="form-input"
                  placeholder="Your Password"
                >
              </div>
              <div class="errorText">
                {{ error }}
              </div>
              <div class="form-field">
                <ps-button
                  v-if="!isSso"
                  id="resetPasswordLinkButton"
                  class="group default-color"
                  :route-link="pscg"
                  target="_blank"
                  text
                >
                  {{ translate("label.forgotPassword") }}
                </ps-button>
              </div>
              <div class="form-field">
                <ps-button
                  v-if="isAuthenticate"
                  id="LoginButton"
                  class="btn"
                  :click="logIn"
                  depressed
                >
                  {{ translate("label.login") }}
                </ps-button>
              </div>
            </v-form>
          </div>
        </div>
        <div class="footer-container">
          <p class="footer-text">
            <span class="version">
              {{ translate("label.version") + " " + version }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <v-container class="fill-height">
        <v-row style="margin-top: 2%">
          <v-col
            cols="3"
            align="left"
          >
            <ps-button
              id="ProfitSwordLinkButton"
              class="loginFormLink"
              href="https://profitsword.com"
              target="_blank"
              text
              depressed
              color="#777"
            >
              {{ translate("label.poweredByProfitSword") }}
            </ps-button>
          </v-col>
          <v-col cols="6" />
          <v-col
            cols="3"
            align="right"
          >
            <div
              class="socialIcons"
              style="float: right"
            >
              <a
                target="_blank"
                href="https://www.facebook.com/profitsword/"
              ><img
                :src="FbLogo"
              ></a>
              <a
                target="_blank"
                href="https://twitter.com/profitsword"
              ><img
                :src="TwitterLogo"
              ></a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/profitsword/"
              ><img
                :src="InLogo"
              ></a>
              <a
                target="_blank"
                href="https://www.instagram.com/profitsword/"
              ><img
                :src="IgLogo"
              ></a>
            </div>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          align="center"
          no-gutters
          style="margin-top:8%; margin-bottom:40px; !important"
        >
          <v-col
            cols="7"
            justify="center"
            align="center"
            class="d-flex elevation-5 flex-row justify-center mb-6 login-card"
            style="background: white; max-width: 680px; min-width: 680px"
          >
            <v-card
              class="d-flex align-content-center flex-wrap"
              min-width="18em"
              style="box-shadow: none; margin: 40px 0 20px 20px"
            >
              <div class="loginLogo">
                <img
                  id="clientLogo"
                  :src="logo"
                  width="80%"
                >
              </div>
              <v-row>
                <v-col class="white--text clientName">
                  {{ psClientName }}
                </v-col>
              </v-row>
            </v-card>
            <v-card
              v-if="!showLanding"
              class="align-content-center"
              min-width="18em"
              tile
              style="
                box-shadow: none;
                margin: 40px 0 20px 20px;
                border-left: 1px solid #d7d7d7;
              "
            >
              <v-card-title class="text-xs-center loginHeader">
                {{ translate("label.welcome") }}
              </v-card-title>
              <v-card-text>
                <v-form
                  v-if="!isSso"
                  @keyup.native.enter="logIn"
                >
                  <ps-textfield
                    id="username"
                    v-model="username"
                    prepend-icon="person"
                    type="text"
                    :label="translate('label.username')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    autofocus
                    style="padding: 0 0.75em; margin-bottom: 0.75em"
                  />
                  <ps-textfield
                    id="password"
                    v-model="password"
                    prepend-icon="lock"
                    type="password"
                    :label="translate('label.password')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    background-color="#1fc2c3"
                    style="padding: 0 0.75em; margin-bottom: 0.75em"
                  />
                  <div class="errorText">
                    {{ error }}
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions class="justify-center">
                <ps-button
                  v-if="isAuthenticate"
                  id="LoginButton"
                  class="loginButton"
                  color="primary"
                  :click="logIn"
                  depressed
                >
                  {{ translate("label.login") }}
                </ps-button>
                <ps-button
                  v-if="!isSso"
                  id="resetPasswordLinkButton"
                  class="loginFormLink"
                  :route-link="pscg"
                  target="_blank"
                  text
                  color="#777"
                >
                  {{ translate("label.forgotPassword") }}
                </ps-button>
              </v-card-actions>
              <v-card-text>
                <v-spacer />
              </v-card-text>
            </v-card>
            <v-card
              v-else
              class="elevation-12"
              tile
            >
              <v-card-text>
                <v-avatar size="40">
                  <ps-image
                    id="userImage"
                    :src="userImage"
                  />
                </v-avatar>
              </v-card-text>
              <v-card-title class="loginHeader">
                {{ translate("label.chooseAnAccount") }}
              </v-card-title>
              <v-card-actions align="left">
                <v-form>
                  <ul class="userList">
                    <li
                      v-for="user in usersWithSameEmail"
                      :key="user.Guid"
                    >
                      <ps-button
                        :id="user.Guid"
                        class="loginFormLink"
                        text
                        :click="userProfileClick"
                      >
                        {{ user.UserName }}
                      </ps-button>
                    </li>
                  </ul>
                  <v-spacer />
                  <ps-button
                    id="btnSignOut"
                    class="loginButton"
                    color="primary"
                    :click="gLogOut"
                    depressed
                  >
                    {{ translate("message.APP_SIGNOUT") }}
                  </ps-button>
                </v-form>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="row-bottom">
          <v-col
            cols="3"
            align="left"
          >
            <a
              href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071"
            >Latest Release Notes</a>
          </v-col>
          <v-col cols="6" />
          <v-col
            cols="3"
            align="right"
          >
            <p
              v-if="version"
              class="version"
            >
              {{ translate("label.version") + " " + version }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import PsLogo from "../assets/logo.png";
import FbLogo from "../assets/social_icons/facebook.svg";
import InLogo from "../assets/social_icons/linked_in.svg";
import TwitterLogo from "../assets/social_icons/twitter.svg";
import IgLogo from "../assets/social_icons/instagram.svg";
import ProfitswordLogo from "../assets/profitsword.svg";
import NewPSLogo from "../assets/ps.svg";
import ByPSLogo from "../assets/by.svg";
import ActblPSLogo from "../assets/actbl.svg";


let payload = {};
export default {
    data() {
        const returnURL = document.URL.split("ReturnURL=")[1];
        let appURL = "";
        if (returnURL.includes("http")) {
            appURL = "&appUrl=" + decodeURIComponent(returnURL.split("PSAuthLoginReturn")[0]) + "Canvas.aspx";
        }
        else {
            appURL = "&appUrl=" + encodeURIComponent(returnURL.split("PSAuthLoginReturn")[0]);
        }
        return {
            isSso: false,
            isAuthenticate: this.checkAuthenticate(),
            showLanding: false,
            userImage: "",
            error: "",
            username: "",
            password: "",
            logo: PsLogo,
            FbLogo: FbLogo,
            InLogo: InLogo,
            TwitterLogo: TwitterLogo,
            IgLogo: IgLogo,
            ProfitswordLogo: ProfitswordLogo,
            NewPSLogo: NewPSLogo,
            ByPSLogo: ByPSLogo,
            ActblPSLogo: ActblPSLogo,
            psClientName: "PS-Authenticate",
            version: this.$route.query.v,
            pscg: "ResetPassword?pscg=" + this.$route.query.pscg + appURL,
            userGuid: "",
            SSOError: "",
            ssoBtnDisabled: false,
            cookieLink: "",
            useActablStyles: false,
        };
    },
    computed: {
        usersWithSameEmail() {
            return this.$store.state.users;
        },
    },
    created() {
        // Reads from url the paramenter of the new design.
        const match = window.location.href.match(/[\?&]useActablStyles=([^&]*)/);
        if (match) {
            const local = decodeURIComponent(match[1].replace(/\+/g, ""));
            this.useActablStyles = local === "Y" ? true : false;
            this.$nextTick(() => {
                // Adjust the html and body class when new design flag is active
                if (this.useActablStyles) {
                    document.documentElement.classList.add("customhtml");
                    document.body.style.background =
            "linear-gradient(64.7deg, #FFFFFF 23.24%, #E5EDFB 57.05%, #FEEADD 94.45%)";
                } else {
                    document.documentElement.classList.remove("customhtml");
                    document.body.removeAttribute("class");
                    document.body.style.background = "";
                }
            });
        }
    },
    mounted() {
        if (this.$route.query.pscg) {
            axios
                .get(
                    localConfig.authenticationURL +
            "/api/ClientPacket/" +
            this.$route.query.pscg
                )
                .then((response) => {
                    if (response.data.psClientName == "")
                        this.$router.push("unauthorized");
                    else {
                        this.psClientName = response.data.psClientName;

                        var psClientDirUrl = response.data.find((item) => {
                            return item.name == "psClientDirUrl";
                        });

                        const SSO = response.data.find(o => o.name === "singleSignOn").value;

                        if (SSO) {
                            this.$store.commit(
                                "setSsoOption",
                                SSO
                            );
                            this.isSso = false;
                            this.isAuthenticate = this.checkAuthenticate();
                        }

                        if (psClientDirUrl.value && !psClientDirUrl.value == "")
                            this.logo = psClientDirUrl.value + "/ClientImages/about.png";
                        else this.logo = PsLogo;
                    }
                })
                .catch((error) => console.log(error));
        }
    },
    methods: {
        userProfileClick() {
            payload = {
                grant_type: "password",
                client_id: this.$route.query.cid,
                scope: this.$route.query.scp + " offline_access",
                username: "*",
                password: "*",
                ps_client: this.$route.query.pscg,
                user_guid: event.currentTarget.id,
                access_token: localStorage.getItem("access_token"),
            };
            this.$store
                .dispatch("internalSsoLogin", payload)
                .then((response) => {
                    if (!this.$route.query.ReturnURL.includes("http")) {
                        this.$router.push({name: this.$route.query.ReturnURL, params: {
                            token :response.data.access_token,
                            rt: response.data.refresh_token
                        }});
                    }
                    else {
                        window.location.replace(
                            this.$route.query.ReturnURL +
              "?token=" +
              response.data.access_token +
              "&rt=" +
              response.data.refresh_token
                        );
                    }
                })
                .catch((error) => {
                    this.error = error.response.data.error_description;
                    return;
                });
        },
      checkAuthenticate() {
        return true;
        },
        checkSso() {
            return (
                this.$store.getters.ssoOption !== "PS-Authenticate" &&
        this.$store.getters.ssoOption !== "None"
            );
        },
        logIn() {
            if (!this.username || !this.password) {
                this.error = this.translate("message.BLANK_USER_PASSWORD"); // Don't bother sending to auth server if we're missing data.
                return false;
            }
            payload = {
                grant_type: "password",
                client_id: this.$route.query.cid,
                scope: this.$route.query.scp + " offline_access",
                username: this.username,
                password: this.password,
                ps_client: this.$route.query.pscg,
                browserId: this.$route.query.browserid,
            };
            this.$store
                .dispatch("login", payload)
                .then((response) => {
                    //Check for MFA
                    if (response.data.pendingMfa) {
                        this.$store.state.browserId = this.$route.query.browserid;
                        this.$store.state.mfaSessionId = response.data.mfaSessionId;
                        this.$store.state.mfaReset = response.data.resetMfa;
                        this.$router.push("/mfa?ReturnURL=" + this.$route.query.ReturnURL);
                    } else if (response.data.error) {
                        this.error = this.translate(
                            "message." + response.data.error_description
                        );
                    } else {
                        if (!this.$route.query.ReturnURL.includes("http")) {
                            this.$router.push({name: this.$route.query.ReturnURL, params: {
                                token :response.data.access_token,
                                rt: response.data.refresh_token
                            }});
                        }
                        else {
                            window.location.replace(
                                this.$route.query.ReturnURL +
                "?token=" +
                response.data.access_token +
                "&rt=" +
                response.data.refresh_token
                            );
                        }            
                    }
                })
                .catch((error) => {
                    //THIS DOES NOT WORK, Won't return proper error, look into axios
                    if (
                        typeof error.response == "undefined" ||
            error.response.status === "404"
                    ) {
                        this.error = "Error contacting authentication server.";
                    } else {
                        this.error = this.translate(
                            "message." + error.response.data.error_description
                        );
                    }
                    return;
                });
        },
    },
};
</script>

<style lang="scss">
@import "../styles/Login.scss";
</style>
